import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=682e22d2&isComponent&outputPath=components%2Findex057b2bbb%2Findex"
import script from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex057b2bbb%2Findex"
export * from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex057b2bbb%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports